import { 
	REQUEST_AUTHENTICATE,
    RECEIVE_USER,
    AUTHENTICATION_FAILURE,
    RECEIVE_TOKEN,
	RECEIVE_CHECK_AUTH_FAILED,
	REQUEST_CHECK_AUTH,
    LOGOUT,
    REQUEST_REGISTER,
    RECEIVE_REGISTERED_USER,
    REGISTRATION_FAILED,
    RECEIVE_ROLES,
    RECEIVE_USERS,
    RECEIVE_ENTITIES,
    SAVE_ROLE,
    SAVE_MY_STATE, USER_DETAIL
 } from './types';

const user = (state = {roles: [], requestingCheckAuth: false, map:{}}, action) => {
	switch(action.type) {
        case USER_DETAIL: return {
            ...state,
            userDetail: action.payload
        }
        case SAVE_MY_STATE: return {
            ...state,
            myData: action.payload
        }
		case REQUEST_AUTHENTICATE: return {
            ...state,
            authenticating: true,
            authencation_error: null
        }
        case RECEIVE_USER: return {
            ...state,
            user: action.payload,
            isAuthenticated: true,
            requestingCheckAuth: false,
            logout: false
        }
        case RECEIVE_ROLES: 
            state.map['Roles'] = action.payload.reduce((a,e)=>{
                a[e._id] =e;
                return a
            },{})
            return {
            ...state,
            roles: action.payload
        }
        case SAVE_ROLE:
            return {
                ...state,
                role: action.payload
            }
        case RECEIVE_USERS: 
            state.map['users'] = action.payload.reduce((a,e)=>{
                a[e._id] =e;
                return a
            },{})
            return {
            ...state,
            users: action.payload
        }
        case RECEIVE_ENTITIES: {
            const {data, type} = action.payload;
            state.map[type] = data.reduce((a,e)=>{
                a[e._id] =e;
                return a
            },{})
            return {
                ...state,
                [type]:data,
            }
        }
        case RECEIVE_TOKEN: return {
            ...state,
            authenticating: false,
            userToken: action.payload,
            isAuthenticated: true,
            authencation_error: null
        }
        case AUTHENTICATION_FAILURE: return {
            ...state,
            authenticating: false,
            authencation_error: action.payload
        }
        case RECEIVE_CHECK_AUTH_FAILED: return {
            ...state,
            failedCheckAuth: true,
            requestingCheckAuth: false,
            user: null,
            isAuthenticated: false
        }
		case REQUEST_CHECK_AUTH: return {
            ...state,
            requestingCheckAuth: true,
            user: null,
            isAuthenticated: false,
            loginToken: null,
            requestLoginPhone: null,
            failedCheckAuth: false
        }
        case LOGOUT: return {
            ...state,
            user: null,
            isAuthenticated: false,
            loginToken: null,
            requestLoginPhone: null,
            authToken: null
        }
        case REQUEST_REGISTER: return {
            ...state,
            registering: true,
            registerError: null
        }
        case REGISTRATION_FAILED: return {
            ...state,
            registering: false,
            registerError: action.payload
        }
        case RECEIVE_REGISTERED_USER: return {
            ...state,
            registering: false,
            registeredUser: action.payload
        }
		default: return state
		
	}
}

export default user;